export default __webpack_public_path__ + "static/media/ethereum.b0046f30.svg";